import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=534ad946&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=534ad946&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ad946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534ad946')) {
      api.createRecord('534ad946', component.options)
    } else {
      api.reload('534ad946', component.options)
    }
    module.hot.accept("./Emoji.vue?vue&type=template&id=534ad946&scoped=true", function () {
      api.rerender('534ad946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Emoji.vue"
export default component.exports